import React, { useState, useEffect } from 'react';

interface CalmBreathingActivityProps {
  timeLeft: number;
  onInteraction: (data: any) => void;
}

export function CalmBreathingActivity({ timeLeft, onInteraction }: CalmBreathingActivityProps) {
  const [breathPhase, setBreathPhase] = useState<'in' | 'hold' | 'out'>('in');
  const [cycleCount, setCycleCount] = useState(0);

  useEffect(() => {
    const breathingCycle = () => {
      // Breathe in for 4 seconds
      setBreathPhase('in');
      setTimeout(() => {
        setBreathPhase('hold');
        // Hold for 2 seconds
        setTimeout(() => {
          setBreathPhase('out');
          // Breathe out for 4 seconds
          setTimeout(() => {
            setCycleCount(prev => prev + 1);
            onInteraction({ type: 'breath_cycle', count: cycleCount + 1, timestamp: Date.now() });
          }, 4000);
        }, 2000);
      }, 4000);
    };

    const interval = setInterval(breathingCycle, 10000);
    breathingCycle(); // Start immediately

    return () => clearInterval(interval);
  }, [cycleCount, onInteraction]);

  return (
    <div className="text-center">
      <p className="text-lg font-semibold text-green-700 mb-8 font-baloo">
        Breathe with the circle! 🌸
      </p>
      <div className="relative w-40 h-40 mx-auto mb-6">
        <div
          className={`w-full h-full rounded-full bg-gradient-to-br from-green-300 to-blue-300 transition-all duration-4000 ease-in-out ${
            breathPhase === 'in' ? 'scale-125' : breathPhase === 'out' ? 'scale-75' : 'scale-100'
          }`}
        >
          <div className="absolute inset-4 rounded-full bg-white bg-opacity-30 flex items-center justify-center">
            <span className="text-2xl font-bold text-green-700 font-baloo">
              {breathPhase === 'in' ? 'In' : breathPhase === 'out' ? 'Out' : 'Hold'}
            </span>
          </div>
        </div>
      </div>
      <p className="text-green-600 font-baloo">
        Breath cycles completed: {cycleCount}
      </p>
    </div>
  );
}
